import React from 'react';
import { useTheme, ThemeText } from '../context/ThemeContext';

const skillGroups = [
  {
    title: 'Frontend',
    items: ['React.js', 'JavaScript', 'HTML5/CSS3', 'Responsive Design', 'Tailwind CSS'],
  },
  {
    title: 'Backend',
    items: ['Rust/Axum', 'Python/FastAPI', 'Node.js', 'RESTful APIs', 'Postgres', 'GCP'],
  },
  {
    title: 'Tools',
    items: ['Git version control', 'Docker', 'Linux/Unix'],
  },
];

const LandingPage = () => {
  const { isVCMode } = useTheme();

  // Dynamically change list of focus areas based on mode
  const focusAreas = isVCMode
    ? ['Enterprise scalability', 'Product-Market Fit', 'AI Integration', 'Team Alignment']
    : ['Cracked programmer', 'AI-enabled products', 'Backend architecture', 'Systems design'];

  return (
    <div className="page-shell page-shell--centered">
      <div className="page-shell__content landing-content">
        <section className="panel panel--padded section-stack landing-panel">
          <div className="hero-layout landing-hero">
            <div className="landing-intro">
              <div className="landing-brand-row">
                <div className="landing-monogram">MGS</div>
                <div className="landing-meta">
                  <span className="landing-meta-label">
                    <ThemeText founder="Hacker Workspace" vc="Professional Portfolio" />
                  </span>
                  <span className="landing-meta-text">
                    <ThemeText
                      founder="Engineering, product thinking, and practical AI"
                      vc="Full-stack engineering & business-driven product delivery"
                    />
                  </span>
                </div>
              </div>

              <div className="eyebrow">
                <ThemeText founder="Full-Stack Engineer" vc="Software Engineer" />
              </div>

              <h1 className="page-title">Max Gaspers Scott</h1>
              <p className="page-subtitle">
                <ThemeText
                  founder="Full-stack engineer building maintainable products, practical AI tools, and Scalable Systems."
                  vc="Developing Frontend and Backend features, AI solutions, and market-viable MVPs."
                />
              </p>

              <div className="landing-chip-row">
                {focusAreas.map((area) => (
                  <span key={area} className="landing-chip">{area}</span>
                ))}
              </div>

              <div className="cta-row">
                {isVCMode ? (<a
                  className="button-link"
                  href="https://www.linkedin.com/in/max-gaspers-scott-575b3a21a/"
                  target="_blank"
                  rel="noopener noreferrer"
                >View Linkedin</a>) :

                  (<a
                    className="button-link"
                    href="https://github.com/max-gaspers-scott"
                    target="_blank"
                    rel="noopener noreferrer"
                  >View Github</a>)}



                <a
                  className="button-link button-link--secondary"
                  href="mailto:gaspersscottma@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Get in touch
                </a>
              </div>

              <h2 className="section-title">Overview</h2>
              <p className="page-copy landing-copy">
                <ThemeText
                  founder="I am a full-stack developer with expertise in building maintainable and scalable code, and building end-to-end features in response to user pain points."
                  vc="I am an experienced full-stack engineer specialized in accelerating product velocity, aligning with business goals, and shipping reliable systems."
                />
              </p>
              <p className="page-copy landing-copy">
                <ThemeText
                  founder="My experience spans across web development, API design, and software architecture. I enjoy creating useful applications and implementing innovative solutions."
                  vc="My expertise includes end-to-end web architectures, and strategic AI integrations. I design software with maintenance costs and long-term scalability in mind."
                />
              </p>

              <div className="status-bar">
                <span>
                  <ThemeText
                    founder="Current focus: Product-minded engineering"
                    vc="Current focus: MVP design & AI product delivery"
                  />
                </span>
                <span>Availability: Open to opportunities</span>
              </div>
            </div>

            <div className="info-card landing-highlight-card">
              <div className="landing-card-label">What I bring</div>
              <h4>Core strengths</h4>
              <p className="landing-highlight-note">
                <ThemeText
                  founder="Strong backend and systems fundamentals. I can and will clean up all the AI slop that somebody pushed without reading, so that you don't have to."
                  vc="High product-velocity execution paired with a robust focus on reliability and ROI."
                />
              </p>
              <ul className="bullet-list">
                {isVCMode ? (
                  <>
                    <li>Rapid MVP development with lean architecture & high scalability</li>
                    <li>Technical leadership & close alignment with business goals</li>
                    <li>Hands-on experience building AI/RAG solutions for enterprise</li>
                  </>
                ) : (
                  <>
                    <li>Backend systems and API design with scalability in mind</li>
                    <li>Strong emphasis on maintainability, iteration, and user feedback</li>
                    <li>I use vim and arch if it means anything</li>
                  </>
                )}
              </ul>
            </div>
          </div>

          <div className="info-grid landing-skills-grid">
            {skillGroups.map((group) => (
              <div key={group.title} className="info-card">
                <h4>{group.title}</h4>
                <ul className="bullet-list">
                  {group.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default LandingPage;
